import React, { useMemo, useState, useCallback } from 'react';
import { Row, Col, Button } from 'reactstrap';
import './Notes2.css';

const ListContactsNotes2 = (props) => {
    const { row, handleEditSwap } = props;

    const [expanded, setExpanded] = useState(false);

    const updatedTS = useMemo(() => {
        const ts = String(row?.timestamp || '');
        if (ts.length < 10) return '';
        return `${parseInt(ts.substr(5, 2), 10)}/${parseInt(ts.substr(8, 2), 10)}/${ts.substr(2, 2)}`;
    }, [row?.timestamp]);

    const toggleExpand = useCallback((e) => {
        e.stopPropagation(); // prevent firing the row click
        setExpanded((v) => !v);
    }, []);

    const fullNoteText = String(row?.notes || '');
    const isLong = fullNoteText.length > 150;
    const displayedText = (!isLong || expanded) ? fullNoteText : fullNoteText.slice(0, 150) + '...';

    const userTitle = useMemo(() => {
        const ts = String(row?.timestamp || '');
        const hh = ts.length >= 16 ? ts.substr(11, 2) : '';
        const mm = ts.length >= 16 ? ts.substr(14, 2) : '';
        const first = row?.user?.firstName || '';
        const last = row?.user?.lastName || '';
        const who = (first || last) ? `${first} ${last}`.trim() : '';
        return `${hh}${mm ? ':' + mm : ''}${who ? ' by ' + who : ''}`.trim();
    }, [row?.timestamp, row?.user?.firstName, row?.user?.lastName]);

    const displayName = `${row?.firstName || ''} ${row?.lastName || ''}`.trim();
    const lines = useMemo(() => displayedText.split('\n'), [displayedText]);

    return (
        
        <Row
            className="notesFormTypeRow pointer"
            onClick={() => handleEditSwap(row?.id)}
        >
            <Col sm={8} className="notesFormTypeComments text-left">
                <>
                    <Row className="notesFormCommentRow">
                        <Col className="pt-1">
                            {lines.map((line, idx) => (
                                <div key={`${idx}`}>
                                    {line}
                                    <br />
                                </div>
                            ))}

                            {isLong && (
                                <div className="mt-2">
                                    <Button color="secondary" size="sm" onClick={toggleExpand}>
                                        {expanded ? 'Show less' : 'Show more'}
                                    </Button>
                                </div>
                            )}
                        </Col>
                    </Row>
                </>
            </Col>

            <Col sm={4} className="notesFormTypeControls text-right mt-2">
                <div className="noteCreatedTimestamp">{updatedTS}</div>
                <div className="noteCreatedTimestamp" title={userTitle}>
                    {displayName}
                </div>
            </Col>
        </Row>
    );
};

export default ListContactsNotes2;